import React from 'react';
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  LinearProgress,
} from '@mui/material';
import { Card } from 'Components/Card'


const getProgressColor = (percentage) => {
  if (percentage >= 70) return '#4CAF50';      // verde
  if (percentage >= 40) return '#FFC107';      // amarelo
  return '#D32F2F';                             // vermelho
};

const EntityProgressTable = ({ title, data }) => {
  return (
    <Card sx={{ padding: 0, textAlign: 'left', boxShadow: 3 }}>
      <Typography variant="subtitle1" fontWeight="bold">
        {title}
      </Typography>

      <TableContainer className="mb-2">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="body2" fontWeight="bold">Entidade</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" fontWeight="bold">Progresso</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" fontWeight="bold">Status</Typography>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Typography variant="body1">{item.label}</Typography>
                </TableCell>

                <TableCell>
                  <LinearProgress
                    variant="determinate"
                    value={item.percentage}
                    sx={{
                      height: 6,
                      borderRadius: 3,
                      backgroundColor: '#EEE',
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: getProgressColor(item.percentage),
                      },
                    }}
                  />
                </TableCell>

                <TableCell>
                  <Typography
                    variant="body2"
                    fontWeight="bold"
                    color={getProgressColor(item.percentage)}
                  >
                    {item.percentage}%
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default EntityProgressTable;
